export default function Footer() {
  const cols = [
    {
      head: "栏目",
      items: [
        ["持续追踪", "#track"],
        ["话题墙", "#topic"],
        ["新瓜速览", "#expose"],
        ["求证台", "#verify"],
        ["专题合集", "#series"],
      ],
    },
    {
      head: "关于本站",
      items: [
        ["内容声明", "#top"],
        ["求证原则", "#verify"],
        ["信息归档", "#track"],
        ["联系反馈", "#top"],
      ],
    },
  ];

  return (
    <footer className="w-full bg-card">
      <div className="mx-auto w-full max-w-6xl px-4 py-10 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-[1.2fr_1fr_1fr_1.2fr]">
          <div>
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-7 w-7 items-center justify-center rounded-md bg-mark text-cream">
                <i className="ri-radar-fill text-sm"></i>
              </span>
              <span className="font-heading text-base font-bold">最近黑料</span>
            </a>
            <p className="mt-3 max-w-xs text-xs leading-relaxed text-faint">
              新近曝光与近期流出信息追踪，只做一手信息整理与背景梳理，内容需以权威渠道核实为准。
            </p>
            <p className="mt-3 text-xs leading-relaxed text-faint">
              本站为页面演示示例，所列内容均为占位性质，不代表真实事件或立场。
            </p>
          </div>

          {cols.map((c) => (
            <div key={c.head}>
              <h4 className="text-xs font-semibold uppercase tracking-widest text-muted">
                {c.head}
              </h4>
              <ul className="mt-3 space-y-2">
                {c.items.map(([label, href]) => (
                  <li key={label}>
                    <a
                      href={href}
                      className="text-sm text-faint transition-colors hover:text-ink"
                    >
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-muted">
              理性吃瓜三连
            </h4>
            <ul className="mt-3 space-y-2 text-xs leading-relaxed text-faint">
              <li>· 先看求证，再下判断</li>
              <li>· 不搬运未证实的「实锤」</li>
              <li>· 关注事件，不网暴个人</li>
            </ul>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-2 border-t border-line pt-5 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-faint">
            © 2026 最近黑料 · 持续追踪站 — 新近曝光 · 近期流出
          </p>
          <p className="text-xs text-faint">内容仅供演示，请理性看待，避免误伤。</p>
        </div>
      </div>
    </footer>
  );
}